// Yes. Javascript apparently has no modulo operator!
// % is remainder: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
export default (a, n) => ((a%n) + n) % n;